if (!customElements.get('blako-main-banner')) {
  class BlakoMainBanner extends HTMLElement {
    constructor() {
      super();
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    }

    connectedCallback() {
      this.desktopMedia = this.querySelector('[data-banner-media="desktop"]');
      this.mobileMedia = this.querySelector('[data-banner-media="mobile"]');
      this.handleViewportChange();

      this.mobileQuery.addEventListener?.('change', this.handleViewportChange);
      this.reducedMotionQuery.addEventListener?.('change', this.handleMotionChange);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    disconnectedCallback() {
      this.mobileQuery.removeEventListener?.('change', this.handleViewportChange);
      this.reducedMotionQuery.removeEventListener?.('change', this.handleMotionChange);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    getActiveMedia() {
      if (this.mobileQuery.matches && this.mobileMedia) return this.mobileMedia;
      return this.desktopMedia;
    }

    loadMedia(container) {
      if (!container || container.dataset.loaded === 'true') return;

      const image = container.querySelector('img[data-src]');
      if (image) {
        image.src = image.dataset.src;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.sizes) image.sizes = image.dataset.sizes;
        image.fetchPriority = 'high';
        image.loading = 'eager';
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-sizes');
      }

      const video = container.querySelector('video');
      if (video) {
        if (video.dataset.poster) video.poster = video.dataset.poster;
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
      }

      container.dataset.loaded = 'true';
    }

    pauseAllVideos() {
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    playActiveVideo() {
      this.pauseAllVideos();
      if (document.hidden || this.reducedMotionQuery.matches) return;

      const video = this.getActiveMedia()?.querySelector('video');
      if (video) video.play().catch(() => {});
    }

    handleViewportChange = () => {
      const activeMedia = this.getActiveMedia();
      this.loadMedia(activeMedia);
      this.playActiveVideo();
    };

    handleMotionChange = () => {
      this.playActiveVideo();
    };

    handleVisibilityChange = () => {
      if (document.hidden) this.pauseAllVideos();
      else this.playActiveVideo();
    };
  }

  customElements.define('blako-main-banner', BlakoMainBanner);
}
